export default __webpack_public_path__ + "static/media/contactimg.f0d30c44.jpg";